import styled from 'styled-components';

const MembersListWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export { MembersListWrapper };
